import { render, staticRenderFns } from "./TabelaEscore.vue?vue&type=template&id=54a88dfe&scoped=true"
import script from "./TabelaEscore.vue?vue&type=script&lang=js"
export * from "./TabelaEscore.vue?vue&type=script&lang=js"
import style0 from "./TabelaEscore.vue?vue&type=style&index=0&id=54a88dfe&prod&lang=css"
import style1 from "./TabelaEscore.vue?vue&type=style&index=1&id=54a88dfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a88dfe",
  null
  
)

export default component.exports